import { appPaths } from "../../Common";
import { BreadcrumbMap } from "../../Layout";

export const breadcrumbsMap: BreadcrumbMap = {
  [appPaths.app.root]: {
    path: appPaths.app.root
  },
  [appPaths.app.addFeedback]: {
    path: appPaths.app.addFeedback,
    replacements: [{ key: "addfeedback", value: "Add Feedback" }]
  },
  [appPaths.app.featureRequests]: {
    path: appPaths.app.featureRequests,
    replacements: [{ key: "featurerequests", value: "Feature Requests" }]
  },
  [appPaths.app.bugReports]: {
    path: appPaths.app.bugReports,
    replacements: [{ key: "bugreports", value: "Bug Reports" }]
  },
  [appPaths.app.resourceRequests]: {
    path: appPaths.app.resourceRequests,
    replacements: [{ key: "resourcerequests", value: "Resource Requests" }]
  },
  [appPaths.app.viewFeedback]: {
    path: appPaths.app.viewFeedback
  },
  [appPaths.app.viewFeatureRequest]: {
    path: appPaths.app.viewFeatureRequest,
    replacements: [{ key: "featurerequests", value: "Feature Requests" }]
  },
  [appPaths.app.viewBugReport]: {
    path: appPaths.app.viewBugReport,
    replacements: [{ key: "bugreports", value: "Bug Reports" }]
  },
  [appPaths.app.viewResourceRequest]: {
    path: appPaths.app.viewResourceRequest,
    replacements: [{ key: "resourcerequests", value: "Resource Requests" }]
  },
  [appPaths.app.admin]: {
    path: appPaths.app.admin
  }
};
